import Reveal from "../Reveal";

const STEPS = [
  {
    img: "/illus/step-call-brief.webp",
    title: "One call, one brief.",
    text: "References, brand kit, formats, volume. Written down so it never needs repeating.",
  },
  {
    img: "/illus/step-footage-in.webp",
    title: "Footage in, cut back.",
    text: "Shared folder. First cut in the agreed window, captioned, sound designed, every ratio you need.",
  },
  {
    img: "/illus/step-keeps-happening.webp",
    title: "It keeps happening.",
    text: "Same lead, same standard, month after month.",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="bg-black section-pad scroll-mt-16">
    <div className="container-x">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.12} className="group">
            <div className="relative aspect-[3/2] overflow-hidden rounded-2xl border border-white/10 bg-[#111]">
              <img
                src={s.img}
                alt=""
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <span className="absolute top-3 left-3 w-9 h-9 rounded-full bg-[#C8F031] text-black font-heading text-xs font-extrabold flex items-center justify-center">
                0{i + 1}
              </span>
            </div>
            <div className="mt-6 md:pr-6">
              <p className="font-heading text-lg md:text-xl font-bold text-white" data-testid={`process-step-${i + 1}`}>
                {s.title}
              </p>
              <p className="mt-2 text-sm text-white/45 leading-relaxed max-w-[320px]">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
